import { useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";
import _ from "underscore";

import { callFunctionIfExists } from "../../utils/GeneralUtils";
import Constants from "../../utils/Constants";

interface Props {
  id?: string;
  type: string;
  field: any;
  existingValue: any;
  onChange: (val: any) => void;
  inputSize: any;
  disabled: boolean;
  placeholder?: string;
  autoFocus: boolean;
}

const Text = ({
  id,
  type,
  field,
  existingValue = null,
  onChange,
  inputSize,
  disabled = false,
  placeholder,
  autoFocus = false,
}: Props) => {
  const [value, setValue] = useState("");
  const inputRef: any = useRef();

  useEffect(() => {
    if (existingValue || existingValue === 0 || existingValue === "") {
      setValue(existingValue ?? "");
    }
  }, [existingValue]);

  // Auto focus and select text when component is mounted
  useEffect(() => {
    if (!autoFocus) return;

    setTimeout(() => inputRef?.current?.select?.());
  }, []);

  const handleInputChange = (
    e: any,
    type: "percent" | "number" | "text" = "text"
  ) => {
    const val = e.target.value;

    setValue(e.target.value);
    callFunctionIfExists(onChange, val);
  };

  return (
    <>
      {type &&
        (type === Constants.FIELDTYPES.TEXT ||
          type === Constants.FIELDTYPES.NUMBER) && (
          <input
            id={`record-input-${field.APIName}`}
            onChange={handleInputChange}
            required={field?.Required}
            value={value}
            disabled={disabled}
            placeholder={placeholder ?? undefined}
            className={`form-control ${
              inputSize === "sm" ? "form-control-sm" : ""
            }`}
            ref={inputRef}
          />
        )}
      {type && type === Constants.FIELDTYPES.PERCENT && (
        <div
          className="d-inline-block"
          style={{ position: "relative", width: "100%" }}
        >
          <input
            id={`record-input-${field.APIName}`}
            className={`pr-4 form-control ${
              inputSize === "sm" ? "form-control-sm" : ""
            }`}
            onChange={handleInputChange}
            required={field?.Required}
            value={value}
            disabled={disabled}
            ref={inputRef}
          />
          <div style={{ position: "absolute", right: 6, top: 4 }}>%</div>
        </div>
      )}
      {type && type === Constants.FIELDTYPES.URL && (
        <Input
          id={`record-input-${field.APIName}`}
          onChange={handleInputChange}
          required={field?.Required}
          bsSize={inputSize ? inputSize : ""}
          type="url"
          value={value}
          disabled={disabled}
        />
      )}
      {type && type === Constants.FIELDTYPES.EMAIL && (
        <Input
          id={`record-input-${field.APIName}`}
          onChange={(val) => handleInputChange(val)}
          required={field?.Required}
          bsSize={inputSize ? inputSize : ""}
          type="email"
          value={value}
          disabled={disabled}
        />
      )}
      {type && type === Constants.FIELDTYPES.LONG_TEXT && (
        <textarea
          id={`record-input-${field.APIName}`}
          className={`form-control ${
            inputSize === "sm" ? "form-control-sm" : ""
          }`}
          onChange={handleInputChange}
          required={field?.Required}
          rows={4}
          value={value}
          disabled={disabled}
          ref={inputRef}
        />
      )}
    </>
  );
};

export default Text;
